<template>
  <div class="lab-flags-container w-full flex mb-10">
    <h4 v-if="labType !== 'pta'" class="text-red">
      Lab Flags available only for PTA Labs.
    </h4>
    <div v-else class="lab-flags-list w-full">
      <div
        class="lab-flag-item w-full flex flex-wrap mb-5"
        v-for="localFlag of localFlags"
        :key="localFlag.uuid"
      >
        <LabFlagContent :flag="localFlag" :saveToApi="saveAndClick" :deleteFlag="deleteFlag" />
      </div>
      <div
        class="add-flag-btn flex text-lg mt-10 cursor-pointer"
        @click.stop="addFlag()"
      >
        <feather-icon icon="PlusCircleIcon" svgClasses="h-6 w-6" class="mr-4" />
        Add flag
      </div>
    </div>
  </div>
</template>
<script>
import uuid from 'uuid'
import { cloneDeep } from 'lodash'
import { mapMutations } from 'vuex'
import LabFlagContent from './LabFlagContent.vue'

export default {
  components: {
    LabFlagContent,
  },
  data() {
    return {
      localFlags: [],
      openFlagIds: [],
    }
  },
  props: {
    flags: {
      type: Array,
      required: true,
    },
    labType: {
      type: String,
      required: true,
    },
    saveToApi: {
      type: Function,
      required: true,
    },
  },
  methods: {
    ...mapMutations('labs', {
      saveFlags: 'STORE_CURRENT_FLAGS',
    }),
    saveAndClick() {
      this.saveFlags(this.localFlags)
      this.saveToApi()
    },
    async deleteFlag(flag) {
      this.localFlags = this.localFlags.filter(item => item.uuid !== flag.uuid);
      this.saveFlags(this.localFlags)
      this.saveToApi()
    },
    addFlag() {
      const tmpId = `${uuid.v4()}`
      this.localFlags.push({ uuid: tmpId, name: 'Flag', correct_answer: '[PLACEHOLDER]', type: 'short-text'})
    },
  },
  created() {
    this.localFlags = cloneDeep(this.flags)
  }
}
</script>
